import { faExternalLink } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

const secondarySessionDataSelector = (state) => state.railInspection.secondarySessionData;
const secondarySelectedImageSelector = (state) => state.railInspection.selectedSecondaryImageTimestamp;

const SecondarySessionBanner = ({ labelsRef }) => {
    const selectedTimestamp = useSelector(secondarySelectedImageSelector);
    const secondarySessionData = useSelector(secondarySessionDataSelector);

    const openSessionLink = useMemo(() => {
        if (!secondarySessionData) return;

        return `${window.location.origin}/rail-inspection/${secondarySessionData.id}/${selectedTimestamp}`;
    }, [secondarySessionData, selectedTimestamp]);

    useEffect(() => {
        console.log({ secondarySessionData });
    }, [secondarySessionData]);

    return (
        <div
            className="absolute InspectionLabel"
            ref={(ref) => {
                labelsRef.current["secondary"] = ref;
            }}>
            <div
                onClick={() => {
                    window.open(openSessionLink, "_blank");
                }}>
                <strong>{secondarySessionData && new Date(parseFloat(secondarySessionData.first_seen) * 1000).toDateString()}</strong>
                <FontAwesomeIcon icon={faExternalLink} />
            </div>
        </div>
    );
};

export default SecondarySessionBanner;
